import React from 'react';

const TemplateDeletedTooltipContent = () => (
  <p style={{ margin: 'auto' }}>
    This template is no longer available
  </p>
);

export default TemplateDeletedTooltipContent;
